module.exports = __webpack_public_path__ + "static/media/13.9062d7b2.jpg";